import { Box } from '@mui/material';
import React, { useEffect } from 'react';

import type { ReactNode as Children } from 'react';

interface PreventCopyPasteProps {
    children: Children;
}

const addClassNameListener = (callback: (className: string) => void) => {
    const elem = document.body;
    let lastClassName = elem.className;
    return window.setInterval(() => {
        const className = elem.className;
        if (className !== lastClassName) {
            callback(className);
            lastClassName = className;
        }
    }, 10);
};

export const PreventCopyPaste = ({ children }: PreventCopyPasteProps) => {
    useEffect(() => {
        const intervalId = addClassNameListener((className: string) => {
            // used mediumZoom classes
            if (className === 'medium-zoom--opened') {
                const background = document.getElementsByClassName(
                    'medium-zoom-overlay'
                )[0];
                const image = document.getElementsByClassName(
                    'medium-zoom-image--opened'
                )[0];
                background &&
                    background.addEventListener('contextmenu', (event) =>
                        event.preventDefault()
                    );
                image &&
                    image.addEventListener('contextmenu', (event) =>
                        event.preventDefault()
                    );
            }
        });

        return () => window.clearInterval(intervalId);
    }, []);

    return (
        <Box
            onContextMenu={(e) => e.preventDefault()}
            sx={{ width: '100%', userSelect: 'none' }}
        >
            {children}
        </Box>
    );
};

export default PreventCopyPaste;
